import { render, staticRenderFns } from "./WorkDashboard.vue?vue&type=template&id=4e11533c&scoped=true&"
import script from "./WorkDashboard.vue?vue&type=script&lang=js&"
export * from "./WorkDashboard.vue?vue&type=script&lang=js&"
import style0 from "./WorkDashboard.vue?vue&type=style&index=0&id=4e11533c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e11533c",
  null
  
)

export default component.exports